module.exports = __webpack_public_path__ + "img/logo_diario.6de2b0ec.png";